module.exports = __webpack_public_path__ + "img/spesialis.0a0c85bf.svg";